export function copyToClipboard(str: string) {
  if (navigator && navigator.clipboard && navigator.clipboard.writeText)
    return navigator.clipboard.writeText(str);
}

export function readFromClipboard() {
  if (navigator && navigator.clipboard && navigator.clipboard.readText)
    return navigator.clipboard.readText();
}
